namespace Areas.Warranty.List {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("Warranty", ["Active", "Completed", "Deleted"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function view() {
        gotoSelected("ListGrid", "/Warranty/Profile/View/");
    }

    export function edit() {
        gotoSelected("ListGrid", "/Warranty/Profile/Edit/");
    }

    export function showCreate() {
        const createWarrantyProfileDialog = new Areas.Dialogs.CreateWarrantyProfileDialog(() => { });
    }

    export function columnViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Warranty/Profile/View/{placeholder}'>View</a>";


        buildCellContent(cellElement,
            () => { return cellInfo.data.warrantyProfileId; },
            linkInfo);
    }
}